import * as focusTrap from 'focus-trap';
// import detectScroll from '@egstad/detect-scroll'
import { getFocusableItems, getNextFocusable, setResponsiveTabIndex } from './utils';

// modified from https://github.com/mrwweb/clicky-menus
export default class MegaMenu {

  constructor( menu, mobileMenu, mobileWrapper, megaMenu, mobileMenuScroll, toggles ) {

    let currentMenuItem, // false or current menu item ID
    currentMegaMenu,
    panelTrap,
    next,
    lastTab,
    prev,
    firstTab,
    panelTraps = {},
    panelFocusables = {},
    hasHandlers = {},
    hasStickyScroll,
    mediaQueryMobile = window.matchMedia('(max-width: 992px)');

    this.init = () => {

      hasStickyScroll = document.documentElement.classList.contains('sticky-scroll');
      menuSetup();

      document.addEventListener('click', closeOpenMenu);

      [mobileMenuScroll,megaMenu].forEach((element) => {
        element.addEventListener('setScrollTop', function(event) {
          const newValue = event.detail.scrollTopValue;
          if (newValue !== undefined) {
            this.scrollTop = newValue;
          }
        });
      });

      toggles.forEach( btn => {
        btn.addEventListener('click', () => {
          setScrollTop([mobileMenuScroll,megaMenu], 0);
          mobileWrapper.classList.toggle('mobile-nav-active');
          document.documentElement.classList.toggle('kill-scroll');
        });
      });
    }

    function setScrollTop(elements, value) {
      const setScrollEvent = new CustomEvent('setScrollTop', {
        detail: {
          scrollTopValue: value
        }
      });
      for (let i = 0; i < elements.length; i++) {
          elements[i].dispatchEvent(setScrollEvent);
      }
    }

    function toggleOnMenuClick(e) {

      const btnId = e.currentTarget.getAttribute('aria-controls');

      // close open menu if there is one
      if (currentMenuItem && btnId !== currentMenuItem) {
        toggleSubmenu(currentMenuItem);
      }

      toggleSubmenu(btnId);
    }

    function killTraps() {
      for (const key in panelTraps) {
        if ( panelTraps[key].active ) panelTraps[key].deactivate();
      }
    }
    function logKeydownHandler(key, handler) {
      cleanupKeydownHandler(key);
      hasHandlers[key] = handler;
      key.addEventListener('keydown', handler);
    }

    function cleanupKeydownHandler(key) {
      if (hasHandlers.hasOwnProperty(key)) {
        key.removeEventListener('keydown', hasHandlers[key]);
        delete hasHandlers[key];
      }
    }

    function toggleSubmenu(btnId) {

      // vars
      const megaPanel = megaMenu.querySelector(`#${btnId}`),
        panelFocusableElements = panelFocusables[btnId],
        btns = document.querySelectorAll(`[aria-controls="${btnId}"]`);
        panelTrap = panelTraps[btnId];
        firstTab = panelFocusableElements[0] || null;
        lastTab = panelFocusableElements[panelFocusableElements.length - 1] || null;
        prev = btns[1];
        next = getNextFocusable(btns[1]);

      // close panel
      if ( btns[0].getAttribute('aria-expanded') === 'true' ) {

        panelTrap.deactivate({
          returnFocus: true
        });
        killTraps();
        btns.forEach(btn => {
          btn.setAttribute('aria-expanded', false);
        });
        megaPanel.setAttribute('inert', true);
        megaPanel.classList.remove('is-open-panel');
        currentMenuItem = false;
        currentMegaMenu = false;

        // remove event listeners and trap classes
        if ( prev ) {
          cleanupKeydownHandler(prev);
          prev.classList.remove('focus-trap-next-up');
        };
        if ( firstTab ) {
          cleanupKeydownHandler(firstTab);
          firstTab.classList.remove('focus-trap-last-item');
        }
        if ( lastTab ) {
          cleanupKeydownHandler(lastTab);
          lastTab.classList.remove('focus-trap-last-item');
        }
        if ( next ) {
          cleanupKeydownHandler(next);
          next.classList.remove('focus-trap-next-up');
        }

      } else {

        // open panel
        btns.forEach(btn => {
          btn.setAttribute('aria-expanded', true);
        });
        megaPanel.removeAttribute('inert');
        megaPanel.classList.add('is-open-panel');

        currentMenuItem = btnId;
        currentMegaMenu = megaPanel;
        if (!megaPanel.classList.contains('dirty')) {
          megaPanel.classList.add('dirty');
        }

        if (panelFocusableElements.length > 0) {
          // trap focus
          panelTrap.activate({
            onPostActivate: () => {
              setTimeout(() => {
                if ( firstTab ) firstTab.focus()
              }, 10);
            }
          });
          if ( firstTab ) logKeydownHandler(firstTab, firstTabDeactivate);
          if ( lastTab ) logKeydownHandler(lastTab, lastTabDeactivate);
        }
      }
    }

    // -- event handlers --
    // shift-tab out of panel
    function firstTabDeactivate(event) {

      if ( event.key === 'Tab' && event.shiftKey ) {
        //
        if ( prev ) prev.classList.add('focus-trap-next-up');
        if ( firstTab ) firstTab.classList.add('focus-trap-initial');
        if ( next ) next.classList.remove('focus-trap-next-up');
        if ( lastTab ) lastTab.classList.remove('focus-trap-initial');

        // Restore focusability of navigation items.
        panelTrap.deactivate({
          onPostDeactivate: () => {
            if ( firstTab ) cleanupKeydownHandler(firstTab);
            if ( prev ) logKeydownHandler(prev, forwardToTrap);
          }
        });
      }
    }
    // tab back into panel
    function forwardToTrap(event) {

      if ( event.key === 'Tab' && !event.shiftKey ) {
        panelTrap.activate();
        if ( prev ) cleanupKeydownHandler(prev);
        if ( firstTab ) logKeydownHandler(firstTab, firstTabDeactivate);
        if ( lastTab ) logKeydownHandler(lastTab, lastTabDeactivate);
      }
    }
    // tab out of panel to next menu item
    function lastTabDeactivate(event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        if ( next ) next.classList.add('focus-trap-next-up');
        if ( lastTab ) lastTab.classList.add('focus-trap-initial');
        if ( prev ) prev.classList.remove('focus-trap-next-up');
        if ( firstTab ) firstTab.classList.remove('focus-trap-initial');

        // Restore focusability of navigation items.
        panelTrap.deactivate({
          onPostDeactivate: () => {
            if ( lastTab ) cleanupKeydownHandler(lastTab);
            if ( next ) logKeydownHandler(next, reverseToTrap);
          }
        });
      }
    }
    // shift-tab back into panel
    function reverseToTrap(event) {
      if (panelFocusableElements.length === 0) return;
      if (event.key === 'Tab' && event.shiftKey) {
        panelTrap.activate();
        if ( next ) cleanupKeydownHandler(next);
        if ( firstTab ) logKeydownHandler(firstTab, firstTabDeactivate);
        if ( lastTab ) logKeydownHandler(lastTab, lastTabDeactivate);
      }
    }

    function closeOnEscKey(e) {
      if (e.keyCode === 27) {

        // we're in a megamenu item
        if (e.target.closest('li.is-open-panel')) {
          document.querySelector(`[data-menu-item='${e.target.closest('li.is-open-panel').dataset.megaPanel}'] button`).focus();
          toggleSubmenu(currentMenuItem);
          // we're on a parent item
        } else if (e.target.getAttribute('aria-expanded') === 'true') {
          toggleSubmenu(currentMenuItem);
        }
      }
    }

    function backButtonClick() {
      toggleSubmenu(currentMenuItem);
    }
    function closeOpenMenu(e) {
      if ( currentMenuItem && currentMegaMenu &&
        e.target.getAttribute('aria-controls') !== currentMenuItem &&
        e.target != currentMegaMenu &&
        !currentMegaMenu.contains(e.target))
      {
        toggleSubmenu(currentMenuItem);
      }
    }

    function setReturnFocus() {
      return document.querySelector('.focus-trap-next-up') ?? true;
    }

    function menuSetup() {

      menu.querySelectorAll('.menu-item').forEach((item, index) => {

        const megaPanel = megaMenu.querySelector(`[data-mega-panel="${item.dataset.menuItem}"]`),
        id = 'megamenu-' + item.dataset.menuItem,
        button = item.querySelector('button'),
        closeButton = megaPanel.querySelector('.close-panel-button'),
        backButton = megaPanel.querySelector('.back-button'),
        navTogglers = document.querySelectorAll('.navbar-toggler'),
        mobileBtn = mobileMenu.querySelectorAll('.menu-item')[index].querySelector('button');

        panelFocusables[id] = getFocusableItems(megaPanel);
        // add focus trap
        panelTraps[id] = focusTrap.createFocusTrap( megaPanel, {
          escapeDeactivates: false,
          clickOutsideDeactivates: true,
          fallbackFocus: button,
          setReturnFocus,
          initialFocus: '.focus-trap-initial'
        });

        setUpAria(megaPanel, button);
        setUpAria(megaPanel, mobileBtn, true);
        if ( backButton ) setResponsiveTabIndex(backButton);
        setResponsiveTabIndex(button, 'max');
        setResponsiveTabIndex(mobileBtn);
        navTogglers.forEach(btn => setResponsiveTabIndex(btn));

        // bind event listener to button
        button.addEventListener('click', toggleOnMenuClick);
        mobileBtn.addEventListener('click', toggleOnMenuClick);
        if (closeButton) {
          closeButton.addEventListener('click', backButtonClick);
        }
        if ( backButton ) backButton.addEventListener('click', backButtonClick);
        menu.addEventListener('keyup', closeOnEscKey);
        megaPanel.addEventListener('keyup', closeOnEscKey);
        mobileMenu.addEventListener('keyup', closeOnEscKey);

      });

      // Centering menu panels with less than three columns
      // Aligns to the center of the menu item
      // Adjusts offset to align with right edge
      updateMenuPanelPositions();

      // Update positions on resize, debounced to every 100ms
      window.addEventListener('resize', debounce(updateMenuPanelPositions, 100));

      if (hasStickyScroll) addStickyScroll();
    }

    function addStickyScroll() {

      // Initialize scroll state object
      const scrollState = {
        // initial scroll position and time
        lastScrollY: window.scrollY,
        lastScrollTime: Date.now(),
        // track scroll direction and velocity
        directionDebounceTime: 300,
        directionChangeTime: 0,
        scrollDirection: 'up',
        scrollVelocity: 0,
        // track accumulated scroll amount
        scrollAmount: 0,
        // threshold for when to update position
        scrollThreshold: 50,
        // throttle scroll events
        isThrottled: false,
        // transition duration
        minDuration: 0.5,
        maxDuration: 0.75,
        // nav height and position
        navHeight: 0,
        navY: 0,
        alertBar: document.querySelector('.alert-bar'),
        alertBarHeight: 0,
        isFixed: false,
        // flag to track initial page load
        isInitialPageLoad: true
      };

      // Get alert bar height from CSS
      const getAlertBarHeight = () => {
        return parseFloat(getComputedStyle(document.body).getPropertyValue('--alert-bar-height')) || 0;
      };

      // Set CSS variable for nav height
      const stickyScrollHeight = () => {
        scrollState.navHeight = document.querySelector('.main-header-wrap').getBoundingClientRect().height;
        scrollState.alertBarHeight = getAlertBarHeight();

        document.documentElement.style.setProperty('--nav-main-height', `${scrollState.navHeight}px`);
      };

      // Call to set initial nav height and add resize listener
      stickyScrollHeight();
      window.addEventListener('resize', debounce(stickyScrollHeight, 100));

      // Function to handle scroll events
      const handleScroll = () => {
        // If already processing a scroll event, skip this one
        if (scrollState.isThrottled) return;
        // Set throttle flag
        scrollState.isThrottled = true;
        // Use requestAnimationFrame to optimize for animation smoothness
        requestAnimationFrame(() => {
          const currentTime = Date.now();
          const currentScrollY = window.scrollY;
          const scrollDelta = currentScrollY - scrollState.lastScrollY;
          const timeDelta = currentTime - scrollState.lastScrollTime;
          const prevDirection = scrollState.scrollDirection;

          // Determine if we should be in fixed mode
          // const shouldBeFixed = currentScrollY > (scrollState.alertBarHeight + scrollState.navHeight);
          const shouldBeFixed = currentScrollY > scrollState.alertBarHeight;

          // Handle transition between scroll modes
          if (shouldBeFixed !== scrollState.isFixed) {
            scrollState.isFixed = shouldBeFixed;

            if (shouldBeFixed) {
              // Switching to fixed mode - start header off-screen to avoid jump
              document.documentElement.classList.add('header-fixed');
              scrollState.navY = -scrollState.navHeight; // Start hidden to match scroll position

              // Immediately show it since we're becoming sticky
              setTimeout(() => {
                scrollState.navY = 0;
                document.documentElement.style.setProperty('--nav-main-wrap-y', `${scrollState.navY}px`);
              }, 16); // Next frame

            } else {
              // Switching to scroll mode
              document.documentElement.classList.remove('header-fixed');
              scrollState.navY = 0; // Reset transform when not fixed
            }

            document.documentElement.style.setProperty('--nav-main-wrap-y', `${scrollState.navY}px`);
          }

          // If we're not in fixed mode, just let it scroll naturally
          if (!scrollState.isFixed) {
            // Update last scroll position and time
            scrollState.lastScrollY = currentScrollY;
            scrollState.lastScrollTime = currentTime;

            // Reset throttle flag
            setTimeout(() => {
              scrollState.isThrottled = false;
            }, 16);
            return;
          }

          // We're in fixed mode - do sticky scroll calculations
          if (scrollDelta !== 0) {
            // Calculate scroll velocity
            if (timeDelta > 0) {
              scrollState.scrollVelocity = Math.abs(scrollDelta) / timeDelta;
            }

            // Determine current scroll direction
            const currentDirection = scrollDelta > 0 ? 'down' : 'up';
            const directionChanged = currentDirection !== prevDirection;

            // Check if enough time has passed since the last direction change
            const timeSinceDirectionChange = currentTime - scrollState.directionChangeTime;
            const allowDirectionChange = timeSinceDirectionChange > scrollState.directionDebounceTime;

            // Calculate transition duration based on velocity
            const velocityFactor = Math.min(1, scrollState.scrollVelocity * 100);
            const duration = scrollState.maxDuration - ((scrollState.maxDuration - scrollState.minDuration) * velocityFactor);
            document.documentElement.style.setProperty('--nav-transition-duration', `${duration}s`);

            // Distance scrolled since becoming fixed
            const scrollSinceFixed = currentScrollY - (scrollState.alertBarHeight + scrollState.navHeight);
            const initY = currentDirection === 'down' ? scrollState.navHeight / 4 : scrollState.navHeight / 2;

            // Apply sticky behavior based on scroll direction and position
            let shouldUpdatePosition = false;

            // If we're close to where fixed mode started, always show header
            if (scrollSinceFixed <= initY) {
              scrollState.navY = 0;
              shouldUpdatePosition = true;
            } else {
              // We're far enough from the transition point to do hide/show logic
              if (directionChanged) {
                // Update direction immediately for future comparisons
                scrollState.scrollDirection = currentDirection;

                // Reset accumulated scroll amount
                scrollState.scrollAmount = 0;

                // Only update position if enough time has passed since last change
                if (allowDirectionChange) {
                  // Record the time of this direction change
                  scrollState.directionChangeTime = currentTime;

                  if (currentDirection === 'down') {
                    // Scrolling down - hide the header
                    scrollState.navY = -scrollState.navHeight;
                  } else {
                    // Scrolling up - show the header
                    scrollState.navY = 0;
                  }
                  shouldUpdatePosition = true;
                }
              } else {
                // Add to accumulated scroll amount for same direction
                scrollState.scrollAmount += Math.abs(scrollDelta);

                // Update position if accumulated scroll exceeds threshold
                if (scrollState.scrollAmount >= scrollState.scrollThreshold) {
                  if (currentDirection === 'down') {
                    scrollState.navY = -scrollState.navHeight;
                  } else {
                    scrollState.navY = 0;
                  }
                  // Reset accumulated scroll amount
                  scrollState.scrollAmount = 0;
                  shouldUpdatePosition = true;
                }
              }
            }

            // Update the CSS variable if position changed
            if (shouldUpdatePosition) {
              document.documentElement.style.setProperty('--nav-main-wrap-y', `${scrollState.navY}px`);
            }

            // Update last scroll position and time
            scrollState.lastScrollY = currentScrollY;
            scrollState.lastScrollTime = currentTime;
          }

          // Reset throttle flag
          setTimeout(() => {
            scrollState.isThrottled = false;
          }, 16);
        });
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      // Initial call to set up state
      handleScroll();
    }

    function setUpAria(megaPanel, button, isMobile = false) {
      const megaPanelId = megaPanel.dataset.megaPanel;

      let id = 'megamenu-' + megaPanelId;

      // set button ARIA
      button.setAttribute('aria-controls', id);
      button.setAttribute('aria-expanded', false);

      // set megamenu ARIA
      if (!isMobile) {
        megaPanel.setAttribute('id', id);
        megaPanel.setAttribute('inert', true);
      }
    }

    // Function to update menu panel positions
    function updateMenuPanelPositions() {

      // Only run on large screens
      if ( mediaQueryMobile.matches ) return;

      const mainmenu = document.querySelector('ul.nav-main-topmenu.mainmenu');
      mainmenu.querySelectorAll('[data-menu-item]').forEach(menuItem => {
        const rect = menuItem.getBoundingClientRect();
        const panel = document.querySelector(`[data-mega-panel="${menuItem.dataset.menuItem}"]`);

        if (panel) {

          const columnNum = panel.style.getPropertyValue('--panel-column-num');
          if (columnNum !== '3') {
            const menuItemCenter = rect.left + (rect.width / 2);
            const panelRect = panel.getBoundingClientRect();
            const menuGap = getComputedStyle(panel).getPropertyValue('--mega-gap');
            const menuGapConverted = clampToInteger(menuGap);

            // Calculate the offset needed from center position
            const offset = menuItemCenter - (window.innerWidth / 2);

            // Check if panel would overflow right edge
            const rightEdge = (window.innerWidth / 2) + offset + (panelRect.width / 2);

            // Fix right overflow
            if (rightEdge > (window.innerWidth - menuGapConverted)) {
              // Adjust offset to align with right edge
              const rightOffset = ((window.innerWidth - (menuGapConverted * 2) - (panelRect.width / 2)) - (window.innerWidth / 2));
              panel.style.setProperty('--panel-offset', `${rightOffset}px`);
            } else {
              // Use centered offset
              panel.style.setProperty('--panel-offset', `${offset}px`);
            }
          }
        }
      });
    }

    function clampToInteger(clampValue) {
      // Extract the values from the clamp function
      const regex = /clamp\(([^,]+),([^,]+),([^,]+)\)/;
      const matches = clampValue.match(regex);

      if (!matches) {
        return 0;
      }

      const min = matches[1].trim();
      const preferred = matches[2].trim();
      const max = matches[3].trim();

      // Function to convert rem and vw to pixels
      const convertToPixels = (value) => {
        if (value.endsWith('rem')) {
          return parseFloat(value) * parseFloat(getComputedStyle(document.documentElement).fontSize);
        } else if (value.endsWith('vw')) {
          return (parseFloat(value) / 100) * window.innerWidth;
        }
        return parseFloat(value);
      };

      // Function to evaluate the preferred value expression
      const evaluatePreferredValue = (expression) => {
        // Replace vw with its pixel equivalent
        const vwValue = (window.innerWidth / 100);
        // Replace vw in the expression
        const modifiedExpression = expression
          .replace(/(\d*\.?\d+)vw/g, (_, num) => num * vwValue) // Convert vw to pixels
          .replace(/(\d*\.?\d+)rem/g, (_, num) => num * parseFloat(getComputedStyle(document.documentElement).fontSize)); // Convert rem to pixels

        // Evaluate the expression safely
        return new Function(`return ${modifiedExpression}`)();
      };

      // Calculate the values in pixels
      const calculateFinalValue = () => {
        const minValue = convertToPixels(min);
        const preferredValue = evaluatePreferredValue(preferred);
        const maxValue = convertToPixels(max);

        // Calculate the final value
        const finalValue = Math.max(minValue, Math.min(preferredValue, maxValue));

        // Return the final value as an integer
        return Math.round(finalValue);
      };
      return calculateFinalValue();
    }

    // Debounce function to limit how often resize calculations happen
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
}